import { forwardRef, type ComponentProps } from "react";
import PhoneInputWithCountry from "react-phone-number-input";
import PhoneInputOnly from "react-phone-number-input/input";
import "react-phone-number-input/style.css";

interface PhoneInputProps
  extends Omit<
    ComponentProps<typeof PhoneInputWithCountry>,
    "value" | "onChange" | "international"
  > {
  value: string;
  onChange: (value: string) => void;
  international?: boolean;
  withCountrySelect?: boolean;
}

const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  (
    {
      value,
      onChange,
      placeholder = "(619) 555-1212",
      className,
      international = true,
      withCountrySelect = true,
      ...props
    },
    ref,
  ) => {
    if (!withCountrySelect) {
      return (
        <PhoneInputOnly
          {...props}
          ref={ref}
          defaultCountry="US"
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          value={value}
          onChange={(val) => onChange(val || "")}
          placeholder={placeholder}
          className={className}
        />
      );
    }
    return (
      <PhoneInputWithCountry
        {...props}
        international={international}
        defaultCountry="US"
        value={value}
        onChange={(val: string | undefined) => onChange(val || "")}
        placeholder={placeholder}
        className={
          className ||
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2"
        }
      />
    );
  },
);
PhoneInput.displayName = "PhoneInput";

export default PhoneInput;
